import { render, staticRenderFns } from "./AssistenciaFuneral.vue?vue&type=template&id=1d3448f2&scoped=true&"
import script from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
export * from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
import style0 from "./AssistenciaFuneral.vue?vue&type=style&index=0&id=1d3448f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3448f2",
  null
  
)

export default component.exports